import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledQuestionReference = styled.div``;

const QuestionReference = ({ children }) => (
  <StyledQuestionReference>
    { children }
  </StyledQuestionReference>
);

QuestionReference.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  // text: PropTypes.string,
};

QuestionReference.defaultProps = {
  children: '',
  // text: '',
};

export default QuestionReference;
